import {
    getUnifiedReviewHistory,
    getUnifiedReviewRecords,
    saveUnifiedReviewBatchDecision,
    saveUnifiedReviewDecision,
    UNIFIED_RISK_TYPE,
} from "@/api/unifiedReviewWorkbench";

function mapVinPlateRecord(record = {}) {
    const detailPayload = record.detailPayload || {};
    const caseNoList = Array.isArray(record.relatedCaseNoList) ? record.relatedCaseNoList.join(",") : "";
    return {
        ...record,
        groupKey: record.bizKey,
        hitDimension: detailPayload.hitDimension || record.extStr1,
        vinCode: detailPayload.vinCode,
        plateNumber: detailPayload.plateNumber,
        policyNo: detailPayload.policyNo,
        caseCount: record.caseCount,
        totalPayAmount: record.totalAmount,
        caseNoList,
        reportDaySpan: detailPayload.reportDaySpan || record.extNum1,
        accidentDaySpan: detailPayload.accidentDaySpan || record.extNum2,
        ruleSnapshot: (record.rulePayload && record.rulePayload.summary) || detailPayload.ruleSnapshot,
        excludeSnapshot: (record.excludePayload && record.excludePayload.summary) || detailPayload.excludeSnapshot,
        reviewStatus: record.reviewDecision || record.reviewStatus || "pending",
        lastReasonCode: record.reasonCode || record.lastReasonCode,
        lastReasonDesc: record.reasonDesc || record.lastReasonDesc,
    };
}

function mapVinPlateHistory(item = {}) {
    return {
        ...item,
        historyId: item.reviewHistoryId || item.historyId,
        beforeReviewStatus: item.beforeReviewDecision || item.beforeReviewStatus,
        afterReviewStatus: item.afterReviewDecision || item.afterReviewStatus,
        beforeCaseCount: item.snapshotPayload?.beforeCaseCount || item.beforeCaseCount,
        afterCaseCount: item.snapshotPayload?.afterCaseCount || item.afterCaseCount,
        beforeTotalPayAmount: item.snapshotPayload?.beforeTotalAmount || item.beforeTotalPayAmount,
        afterTotalPayAmount: item.snapshotPayload?.afterTotalAmount || item.afterTotalPayAmount,
        beforeHitDimension: item.snapshotPayload?.beforeHitDimension || item.beforeHitDimension,
        afterHitDimension: item.snapshotPayload?.afterHitDimension || item.afterHitDimension,
    };
}

export function getVinPlateRepeatReviewRecords(apiBaseurl = "", params = {}, httpClient) {
    return getUnifiedReviewRecords(apiBaseurl, {
        riskType: UNIFIED_RISK_TYPE.VIN_PLATE_REPEAT,
        reviewStatus: params.reviewStatus || "all",
        reviewDecision: params.reviewDecision || "pending",
        pageNo: params.pageNo || 1,
        pageSize: params.pageSize || 20,
        extFilter1: params.hitDimension || "all",
    }, httpClient, mapVinPlateRecord);
}

export function getVinPlateRepeatReviewHistory(apiBaseurl = "", riskEventId, httpClient) {
    return getUnifiedReviewHistory(apiBaseurl, riskEventId, httpClient, mapVinPlateHistory);
}

export function saveVinPlateRepeatReviewDecision(apiBaseurl = "", riskEventId, payload = {}, httpClient) {
    return saveUnifiedReviewDecision(apiBaseurl, riskEventId, payload, httpClient, mapVinPlateRecord);
}

export function saveVinPlateRepeatReviewBatchDecision(apiBaseurl = "", payload = {}, httpClient) {
    return saveUnifiedReviewBatchDecision(apiBaseurl, {
        riskType: UNIFIED_RISK_TYPE.VIN_PLATE_REPEAT,
        riskEventIds: payload.riskEventIds || [],
        decision: payload.decision,
        decisionNote: payload.decisionNote,
    }, httpClient);
}
